var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bread-crumb',{attrs:{"location":"제품검색"}}),_c('top-area',{attrs:{"searchWord":_vm.searchWord,"recommendedProduct":_vm.recommendedProduct},on:{"search-data":_vm.searchData}}),_c('result',{attrs:{"searchWord":_vm.searchWord,"searchedProducts":_vm.searchedProducts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }